import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border/50">
        <div className="px-4 py-4">
          <div className="flex items-center gap-3 max-w-3xl mx-auto">
            <button 
              onClick={() => navigate(-1)}
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
              data-testid="back-btn"
            >
              <ChevronLeft className="w-5 h-5 text-foreground" />
            </button>
            <h1 className="text-xl font-heading text-foreground">Terms of Service</h1>
          </div>
        </div>
      </div>

      <main className="px-4 py-8 max-w-3xl mx-auto">
        <div className="prose prose-invert max-w-none">
          <p className="text-foreground/70 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">1. Acceptance of Terms</h2>
            <p className="text-foreground/70 leading-relaxed">
              By accessing and using Compass (the "Service"), you accept and agree to be bound by the terms 
              and provisions of this agreement. If you do not agree to abide by these terms, please do not 
              use this service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">2. Description of Service</h2>
            <p className="text-foreground/70 leading-relaxed">
              Compass is a personal transformation and self-development platform that provides daily signals, 
              journaling tools, and guided resources for personal growth. The Service is provided "as is" 
              for educational and personal development purposes.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">3. User Responsibilities</h2>
            <p className="text-foreground/70 leading-relaxed mb-3">
              As a user of the Service, you agree to:
            </p>
            <ul className="list-disc list-inside text-foreground/70 space-y-2">
              <li>Provide accurate and complete information when creating your account</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the Service only for lawful purposes</li>
              <li>Not attempt to interfere with the proper functioning of the Service</li>
              <li>Not share or distribute content from the Service without permission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">4. Intellectual Property</h2>
            <p className="text-foreground/70 leading-relaxed">
              All content, features, and functionality of the Service, including but not limited to text, 
              graphics, logos, and software, are the exclusive property of TrueNorth Zone and are protected 
              by copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">5. Disclaimer</h2>
            <p className="text-foreground/70 leading-relaxed">
              The content provided through Compass is for informational and educational purposes only. 
              It is not intended to be a substitute for professional medical advice, diagnosis, or treatment. 
              Always seek the advice of qualified professionals for any health concerns.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">6. Limitation of Liability</h2>
            <p className="text-foreground/70 leading-relaxed">
              TrueNorth Zone shall not be liable for any indirect, incidental, special, consequential, 
              or punitive damages resulting from your use of or inability to use the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">7. Changes to Terms</h2>
            <p className="text-foreground/70 leading-relaxed">
              We reserve the right to modify these terms at any time. We will notify users of any 
              material changes by posting the new terms on this page. Your continued use of the 
              Service after any such changes constitutes your acceptance of the new terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-heading text-foreground mb-4">8. Contact</h2>
            <p className="text-foreground/70 leading-relaxed">
              For any questions about these Terms, please contact us at{" "}
              <a href="mailto:info@truenorth-zone.com" className="text-primary hover:underline">
                info@truenorth-zone.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
